import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getDefaultConfigByType } from '../../../../services/utils/planningDefaults';
import { glossaire_type_de_vue as toto } from 'ressources/glossaires/glossaire_type_de_vue';
import { getAllCapteurByProjectId } from 'services/api';
import CommonPlanningFormFields from './CommonPlanningFormFields';

interface PlanningElectrovanneFormProps {
  project_id?: string | number;
  view_name?: string;
  description?: string;
  affichageProfil?: boolean;
  viewId?: number;
  selectedSensors?: any[];
  setSelectedSensors: (s: any[]) => void;
  onDataChange?: (data: any) => void;
  erreurs?: Record<string, string[]>;
}

const PlanningElectrovanneForm = ({
  project_id = '',
  view_name = '',
  description = '',
  affichageProfil = false,
  viewId,
  selectedSensors = [],
  setSelectedSensors,
  onDataChange = () => {},
  erreurs,
}: PlanningElectrovanneFormProps) => {
  const [projectId, setProjectId] = useState<string | number>(project_id || '');
  const [viewType] = useState<number>(toto.planning_electrovanne);
  const [viewName, setViewName] = useState<string>(view_name || '');
  const [descriptionState, setDescriptionState] = useState<string>(
    description || ''
  );
  const [sensorList, setSensorList] = useState<any[]>([]);

  const listeProjets = useSelector(
    (state: any) => state.authentifie.filtre_projects_list_id
  );

  useEffect(() => {
    const getSensors = async () => {
      const response = await getAllCapteurByProjectId({
        projects_id: project_id ? [project_id] : listeProjets,
      });
      setSensorList(response.sensors_list || []);
      setSelectedSensors([]);
    };
    getSensors();
  }, [project_id]);

  useEffect(() => {
    setProjectId(project_id || '');
    setViewName(view_name || '');
    setDescriptionState(description || '');
  }, [project_id, view_name, description]);

  useEffect(() => {
    onDataChange({
      project_id: projectId,
      view_type: viewType,
      view_name: viewName,
      description: descriptionState,
      selectedSensors,
      // Configuration par défaut spécifique pour Électrovanne
      defaultConfig: getDefaultConfigByType(viewType),
    });
  }, [
    projectId,
    viewType,
    viewName,
    descriptionState,
    selectedSensors,
    onDataChange,
  ]);

  return (
    <CommonPlanningFormFields
      projectId={projectId}
      setProjectId={setProjectId}
      viewName={viewName}
      setViewName={setViewName}
      description={descriptionState}
      setDescription={setDescriptionState}
      affichageProfil={affichageProfil}
      sensorList={sensorList}
      selectedSensors={selectedSensors}
      setSelectedSensors={setSelectedSensors}
      viewId={viewId}
      erreurs={erreurs}
    />
  );
};

export default PlanningElectrovanneForm;
